import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=6b6d696a&scoped=true&"
import script from "./tile.vue?vue&type=script&lang=js&"
export * from "./tile.vue?vue&type=script&lang=js&"
import style0 from "./tile.vue?vue&type=style&index=0&id=6b6d696a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d696a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6d696a')) {
      api.createRecord('6b6d696a', component.options)
    } else {
      api.reload('6b6d696a', component.options)
    }
    module.hot.accept("./tile.vue?vue&type=template&id=6b6d696a&scoped=true&", function () {
      api.rerender('6b6d696a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/tile/tile.vue"
export default component.exports